import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/audit')({
  beforeLoad: () => getAuditLogsTitleContextSlice(),
});
